import { render, staticRenderFns } from "./IconPepperHot.vue?vue&type=template&id=682dc856&"
import script from "./IconPepperHot.vue?vue&type=script&lang=js&"
export * from "./IconPepperHot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports